/** Legal-approved copy — do not edit without Jeff's sign-off. */

export const LEGAL_STRINGS = {
  // String 1 (Footer)
  FOOTER_DISCLAIMER: 'AI can make mistakes. Review, verify, and approve all content before use.',

  // String 2 (Generation Pane)
  GENERATION_PANE_DISCLAIMER: 'Drafts are grounded in your evidence library with citations. Check every claim against the cited source before approving.',

  // String 3 (Approval Action)
  APPROVAL_ACTION_LABEL: 'Approve — I have reviewed this content and verified its claims against our sources.',

  // String 4 (Export Marking)
  EXPORT_MARKING_FOOTER: 'Created with AI assistance. Reviewed and approved by [approver name], [date].',

  // String 5 (Allowed Framing Copy)
  ALLOWED_FRAMING_COPY: 'traceable to your sources — verification stays human.',
} as const;

export type LegalStringKey = keyof typeof LEGAL_STRINGS;
